var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BDropdownItem, BImg, BNavItemDropdown, } from 'bootstrap-vue';
import Component, { mixins } from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
// @ts-ignore
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
// eslint-disable-next-line import/named
import { countryCodeOfLocale, getAllLocales, getSupportedLocales, localeName, } from '@/service/api/core/enums/locale';
import DatesAndTimesMixin from '@/mixin/datesAndTimes';
// eslint-disable-next-line no-use-before-define
let Locale = class Locale extends mixins(DatesAndTimesMixin) {
    constructor() {
        super(...arguments);
        this.perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        };
        /* eslint-disable global-require */
        this.locales = this.shouldDisplayAllLocales ? getAllLocales() : getSupportedLocales();
    }
    async onChangeLocale(locale) {
        this.$emit('locale-changed', locale);
    }
};
__decorate([
    Inject('adminApi')
], Locale.prototype, "adminApi", void 0);
__decorate([
    Prop({ default: false })
], Locale.prototype, "shouldDisplayAllLocales", void 0);
__decorate([
    Prop({ required: true })
], Locale.prototype, "currentLocale", void 0);
__decorate([
    Prop({ default: '' })
], Locale.prototype, "labelClass", void 0);
__decorate([
    Prop({ default: false })
], Locale.prototype, "isNavbar", void 0);
__decorate([
    Prop({ default: false })
], Locale.prototype, "disableOptions", void 0);
__decorate([
    Prop({ default: () => [] })
], Locale.prototype, "enabledOptions", void 0);
Locale = __decorate([
    Component({
        methods: { localeName, countryCodeOfLocale },
        components: {
            BNavItemDropdown,
            BDropdownItem,
            BImg,
            VuePerfectScrollbar,
        },
    })
], Locale);
export default Locale;
